// Build-time config for the Barel Chrome extension.
//
// `VITE_BAREL_EXTENSION_ID`  — Chrome extension id, used by
//   `useExtensionPresence()` to ping the extension via
//   `chrome.runtime.sendMessage`.
// `VITE_BAREL_EXTENSION_URL` — Chrome Web Store install URL. When unset
//   we fall back to the CWS landing page so the install link always
//   resolves to something useful while the extension awaits publication.

interface ViteExtensionEnv {
  readonly VITE_BAREL_EXTENSION_ID?: string;
  readonly VITE_BAREL_EXTENSION_URL?: string;
}

const env = import.meta.env as ImportMetaEnv & ViteExtensionEnv;

const CWS_FALLBACK_URL = 'https://chromewebstore.google.com/';

export const BAREL_EXTENSION_ID: string | undefined =
  env.VITE_BAREL_EXTENSION_ID && env.VITE_BAREL_EXTENSION_ID.length > 0
    ? env.VITE_BAREL_EXTENSION_ID
    : undefined;

export const BAREL_EXTENSION_INSTALL_URL: string =
  env.VITE_BAREL_EXTENSION_URL && env.VITE_BAREL_EXTENSION_URL.length > 0
    ? env.VITE_BAREL_EXTENSION_URL
    : CWS_FALLBACK_URL;

/** True when a real CWS listing has been wired up. */
export const HAS_PUBLISHED_EXTENSION: boolean = BAREL_EXTENSION_INSTALL_URL !== CWS_FALLBACK_URL;
